import { ISuggestResponseSchema } from '../../repositories/newbuilding-promos/entities/suggest/SuggestResponseSchema';
import { ESuggestionType, ISuggestionItem } from '../../types/suggestions';
import { mapJsonQuery } from '../jsonQuery';

export const mapSuggestions = (response: ISuggestResponseSchema): ISuggestionItem[] => {
  const suggestions = response.suggestions;

  return suggestions.map(suggestion => {
    return {
      ...suggestion,
      type: suggestion.type as unknown as ESuggestionType,
      jsonQuery: mapJsonQuery(suggestion.jsonQuery),
    };
  });
};
